import React from 'react';

const WithdrawalElementContainer = (props: {
    children: React.ReactElement | React.ReactElement[];
    className?: string;
}) => <div className={`py-6 px-3 l:max-w-3xl l:mx-auto ${props.className ?? ''}`}>{props.children}</div>;

export default WithdrawalElementContainer;
